/* Featured products carousel — prev/next scrollBy, port of ProductCarousel.jsx. */

(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.carouselReady === 'true') return;
    root.dataset.carouselReady = 'true';

    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    function scroll(direction) {
      track.scrollBy({
        left: direction * track.clientWidth * 0.8,
        behavior: 'smooth'
      });
    }

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { scroll(-1); });
    if (next) next.addEventListener('click', function () { scroll(1); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-featured-products]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor: re-bind when the section is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
